import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { map, length, pipe, ifElse, any, uniqBy, prop } from 'ramda';
import { ICandidate } from '../../common/models/candidate/ICandidate';
import { ICandidatePositionProfile } from '../../common/models/candidate/ICandidatePositionProfile';
import { IBindingCallback1 } from '../../common/models/callback';
import { requestAdditionalReferencesRoutine } from '../../scenes/RequestBuilder/routines';
import { IRefReqSelectedContact } from '../../common/models/contact/IRefReqSelectedContact';
import { IRequestAdditionalReferences } from '../../common/models/referenceRequest/IRequestAdditionalReferences';
import { CandidateStatus } from '../../common/enums/CandidateStatus';
import Icon from '../../components/Icon';
import RegularButton from '../../components/RegularButton';
import { IFormattedMessage } from '../../common/models/common/IFormattedMessage';

type Candidate = ICandidate | ICandidatePositionProfile;
interface IRequestAdditionReferencesProps {
  candidates: Candidate[];
  requestAdditionalReferences: IBindingCallback1<IRequestAdditionalReferences>;
}

const RequestAdditionReferences: FunctionComponent<IRequestAdditionReferencesProps> = ({
  candidates,
  requestAdditionalReferences
}) => {
  const differentPosition = pipe<Candidate[], Candidate[], number, boolean>(
    uniqBy(prop('positionId')),
    length,
    ifElse(res => res !== 1, () => true, () => false)
  )(candidates);
  const inactiveCandidates = any(({ status }) => status !== CandidateStatus.Active, candidates);
  const disabled = differentPosition || inactiveCandidates;
  let tooltip: IFormattedMessage | undefined;

  if (inactiveCandidates) {
    tooltip = { id: 'bulkDisabled.inactive', defaultMessage: 'Candidates should be active' };
  } else if (differentPosition) {
    tooltip = { id: 'bulkDisabled.moreRef', defaultMessage: 'Position must be the same' };
  }

  const onRequestAdditionalReferences = () => {
    const mappedCandidates = map(c => ({
      firstName: c.firstName,
      lastName: c.lastName,
      email: c.email,
      phoneNumber: c.phoneNumber,
      id: c.contactId,
      activeCandidate: {
        id: c.id,
        position: c.position,
        refCount: c.totalRequested
      }
    } as IRefReqSelectedContact), candidates);
    const refReq = {
      candidates: mappedCandidates,
      selectedPosition: {
        id: candidates[0].positionId,
        name: candidates[0].position
      }
    };
    requestAdditionalReferences(refReq);
  };

  return (
    <RegularButton
      textIntlId="iconButtonLable.moreReferences"
      defaultMessage="More references"
      disabled={disabled}
      variant="tertiary"
      icon={<Icon icon="userPlus" className="icon" />}
      tooltip={tooltip}
      onClick={() => onRequestAdditionalReferences()}
    />
  );
};

const mapDispachToProps = {
  requestAdditionalReferences: requestAdditionalReferencesRoutine
};

export default connect(null, mapDispachToProps)(RequestAdditionReferences);
